module.exports = __webpack_public_path__ + "img/logo_new.4065d34.svg";